module.exports = __webpack_public_path__ + "img/product5.c0caa704.png";